import { matchPath } from 'react-router-dom';
import find from 'lodash/find';

import { PageName, RsRoute } from '@Pages/RetroSynthesis/routes';

export const pagePathNameMapper = {
  [RsRoute.PROJECT_ROUTE_TREE_VIEW]: PageName.TREE_VIEW,
};

export const getPageNameByPath = (pathname) => find(pagePathNameMapper, (name, path) => !!matchPath(pathname, { path }));
